<template>
  <el-menu
      v-if="navStatus === 'saved'"
      :default-active.sync="activeLink"
      :mode="mode"
      @select="goToView"
      :unique-opened="true"
      background-color="transparent"
      class="main-navigation-menu"
      :class="{ 'nav-collapsed': isCollapse }"
      :router="true"
  >
    <br/>
    <div v-for="(nav, idx) in sidebarNav" :key="idx" style="color:#B7BCC1;">
      <el-menu-item
          class="mr-27"
          style="margin-bottom: -15px"
          v-if="!nav.submenu && nav.title === 'Assets'"
          :index="nav.link"
      >
        <div slot="title" class="box grow flex">
          <span class="material-icons" v-if="nav.type === 'material'">{{ nav.icon }}</span>
          <span :class="nav.icon" class="box nav-icon" v-else></span>
          <span class="box grow subtitle1 nav-heading"
          ><span class="format-text">{{ nav.title }}</span></span
          >
          <el-badge class="asset-count-badge">{{ activeAgentSummary.unprotectedCount }}</el-badge>
        </div>
      </el-menu-item>

      <el-menu-item class="mb-8" v-if="!nav.submenu && nav.title === 'Settings'" :index="nav.link">
        <div slot="title" class="box grow flex">
          <span class="material-icons" v-if="nav.type === 'material'">{{ nav.icon }}</span>
          <span :class="nav.icon" class="box nav-icon" v-else></span>
          <span class="box grow body1 nav-heading"
          ><span class="format-text">{{ nav.title }}</span></span
          >
        </div>
      </el-menu-item>

      <el-menu-item class="mt-30 mb-8" v-if="!nav.submenu && nav.title === 'Reports'" :index="nav.link">
        <div slot="title" class="box grow flex">
          <span class="material-icons" v-if="nav.type === 'material'">{{ nav.icon }}</span>
          <span :class="nav.icon" class="box nav-icon" v-else></span>
          <span class="box grow body1 nav-heading"
          ><span class="format-text">{{ nav.title }}</span></span
          >
        </div>
      </el-menu-item>

      <el-menu-item v-if="!nav.submenu && nav.title !== 'Assets' && nav.title !== 'Settings' && nav.title !== 'Reports'"
                    :index="nav.link">
        <div slot="title" class="box grow flex">
          <span class="material-icons" v-if="nav.type === 'material'">{{ nav.icon }}</span>
          <span :class="nav.icon" class="box nav-icon" v-else></span>
          <span class="box grow body1 nav-heading"
          ><span class="format-text">{{ nav.title }}</span></span
          >
        </div>
      </el-menu-item>

      <div v-if="nav.submenu && nav.submenu.length > 0" class="main-navigation-submenu">
        <div slot="title" class="box grow flex" style="margin-top:30px;">
          <span class="material-icons" v-if="nav.type === 'material'">{{ nav.icon }}</span>
          <span :class="nav.icon" class="box nav-icon" v-else></span>
          <span class="box grow subtitle1 nav-heading"
          ><span class="format-text">{{ nav.title }}</span></span
          >
        </div>

        <el-menu-item
            v-for="(submenu, idx) in nav.submenu"
            :key="idx"
            :index="submenu.link"
            style="margin-bottom:-15px;"
        >
          <div slot="title" class="box grow flex">
            <span :class="submenu.icon" class="box body1"></span>
            <span class="box grow body1 submenu-title" style="margin-bottom:8px;"
            ><span class="format-text">{{ submenu.title }}</span></span
            >
          </div>
        </el-menu-item>
      </div>
    </div>
  </el-menu>
</template>

<script>
import {mapGetters} from 'vuex'
import {FETCH_NAV, NAV_SUCCESS, UPDATE_NAV} from '@/store/modules/navigation/nav.type'

export default {
  name: 'TheNav',
  props: ['mode', 'isCollapse'],
  data() {
    return {
      isIe: true,
      isEdge: true,
      activeLink: null
    }
  },
  methods: {
    getPathInfo(routeLink, sideNav) {
      let foundNavObj = {}

      for (let i = 0; i < sideNav.length; i++) {
        if (sideNav[i].link === routeLink) {
          foundNavObj = sideNav[i]
          break
        } else if (sideNav[i].submenu) {
          foundNavObj = this.getPathInfo(routeLink, sideNav[i].submenu)
          if (!_.isEmpty(foundNavObj)) break
        }
      }

      return foundNavObj
    },
    goToView(index, indexPath) {
      if (index.charAt(0) === '/') {
        this.$router.push(index)
      }

      // index is the route
      let sideNavObj = this.getPathInfo(index, this.sidebarNav)
      this.$emit('push-page', {page: index, sideNav: sideNavObj})
    },
    setLink(route) {
      if (route.path instanceof Object) {
        this.activeLink = route.path.page
      } else {
        if (route.name === 'windows-dns-requests-insights') {
          this.activeLink = '/insights';
        } else if (['hosts', 'containers', 'container-images'].includes(route.name)) {
          this.activeLink = '/assets/hosts'
        } else if (['active-cyber-attacks', 'mitigated-cyber-attacks'].includes(route.name)) {
          this.activeLink = '/monitor/cyber-attacks/active';
        } else if (['anomalies-detections', 'anomalies-rules'].includes(route.name)) {
          this.activeLink = '/Anomalies';
        } else if (['attack-rules', 'privileged-rules'].includes(route.name)) {
          this.activeLink = '/monitor/rules/attack'
        } else if (route.name === 'threat-hunting') {
          this.activeLink = '/threat-hunting?search=date_range:PAST_24_HOURS+edgeName:in:exec:file:network:system:user';
        } else if (
          [
            'windows-dns-requests-insights',
            'windows-external-connections-insights',
            'windows-logon-failures-insights',
            'windows-privileged-executions-insights',
            'linux-process-launching-shells-insights',
            'linux-privileged-executions-insights',
            'linux-login-failures-insights',
            'linux-sensitive-file-access-insights',
            'linux-external-connections-insights'
          ].includes(route.name)
        ) {
          this.activeLink = '/insights/windows-dns-requests'
        } else if (route.name === 'account') {
          this.activeLink = '/admin/account?view=profile';
        } else if (route.name === 'trail-iocs') {
          this.activeLink = '/detections'
        } else if (['reports-templates', 'reports-scheduled'].includes(route.name)) {
          this.activeLink = '/reports'
        } else {
          this.activeLink = route.path
        }
      }
    }
  },
  created() {
    this.isIe = false
    this.isEdge = false

    this.setLink(this.$router.currentRoute)
    this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute)
    })
    console.log("sideNavObj ", this.getPathInfo(this.$router.currentRoute.path, this.sidebarNav))
    // browser refresh - fetch and process navigation menu
    if (!_.isEmpty(this.isAuthenticated) && _.isEmpty(this.sidebarNav) && this.$route.name !== 'logout') {
      this.$store.dispatch(FETCH_NAV).then(nav => {
        let permissions = _.flatten(_.map(this.userRoles, 'permissions'))
        this.$store.dispatch(UPDATE_NAV, permissions)
        let sideNavObj = this.getPathInfo(this.$router.currentRoute.path, this.sidebarNav)
        this.$emit('push-page', {page: sideNavObj.link, sideNav: sideNavObj})
        this.$store.dispatch(NAV_SUCCESS)
      })
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'navStatus', 'sidebarNav', 'userRoles', 'activeAgentSummary'])
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.el-menu {
  border: none;
}

.el-menu::before,
.el-menu::after {
  display: none;
}

.el-submenu,
.el-menu-item {
  .mdi {
    vertical-align: middle;
    margin-right: 5px;
    display: inline-block;
    width: 24px;
    text-align: center;
    font-size: 18px;
  }
}

h2,
.subtitle1 {
  color: var(--gray-200);
}

.body1 {
  color: white;
}

.el-menu-item {
  padding-left: 0px !important;
}

.subtitle1.nav-heading {
  margin: 0px 0px -4px 0px;
}

.nav-heading {
  margin: 8px 0px 8px 0px;
  padding-left: 8px !important;
}

.submenu-title {
  margin: 8px 0px;
}

.logo-letter {
  width: 125px;
  height: 30px;
  margin: 5px auto;
  margin-bottom: 27px;
  display: block;
}

.main-navigation-submenu {
  > div {
    margin: 0px 16px;
  }

  .el-menu-item {
    padding-left: 24px !important;
    margin: 0px 0px;
  }
}

.material-icons {
  margin: auto;
  color: var(--aluminum-500);
  font-size: 16px !important;

  &:hover {
    font-size: 16px !important;
    line-height: 24px;
    background-color: none;
  }
}
</style>

<style>
@import 'assets/styles/_variables.css';

.main-navigation-menu {
  height: 100%;
  transition: width 0.5s;

  .nav-icon {
    height: 16px;
    width: 16px;
    margin: auto;
    background: var(--aluminum-500);
  }

  .c-icon-lock {
    mask: url('/static/images/lock.svg');
    mask-size: 80%;
    mask-repeat: no-repeat;
  }

  .c-icon-hosts {
    mask: url('/static/images/hosts.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
  }

  .c-icon-star {
    mask: url('/static/images/star.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
  }

  .c-icon-reporting {
    mask: url('/static/images/Report_clipboard.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 19px;
    width: 15px;
  }

  .c-icon-settings {
    mask: url('/static/images/settings.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
  }

  .c-icon-monitor {
    mask: url('/static/images/monitor.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
  }

  .c-icon-asset {
    mask: url('/static/images/asset.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 9px;
    width: 14px;
  }

  .c-icon-threats {
    mask: url('/static/images/threat-icon.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 14px;
    width: 17px;
  }

  .c-icon-policy {
    mask: url('/static/images/policy.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 14px;
    width: 14px;
  }

  .c-icon-intr {
    mask: url('/static/images/interception.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 13px;
    width: 13px;
  }

  .c-icon-analytics {
    mask: url('/static/images/analytics.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 15px;
    width: 15px;
  }

  .c-icon-setups {
    mask: url('/static/images/setup.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 15px;
    width: 14px;
  }

  .c-icon-account {
    mask: url('/static/images/account.svg');
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 13px;
    width: 13px;
    /* background-color: #B7BCC1; */
  }

  > div {
    /* border-bottom: 1px solid var(--aluminum-700); */
  }

  &:not(.el-menu--collapse) {
    .el-submenu__title,
    .el-menu-item {
      height: 40px;
      line-height: 40px;
      background-color: transparent;
      margin-bottom: 0px;
    }

    &:not(.el-menu--horizontal) {
      .el-menu-item,
      .el-submenu {
        position: relative;

        &::before {
          content: '';
          display: none;
        }

        &:hover {
          background-color: none !important;

          &::before {
            display: none;
          }

          .format-text {
            font-weight: bold;
            color: #ffffff;
          }
        }

        &.is-active {
          background-color: none !important;
          /* opacity: 0.5; */

          &::before {
            display: none;
          }

          .format-text {
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
    }

    .el-menu-item {
      > div {
        margin-left: 16px;
      }
    }

    .el-submenu.is-opened {
      position: relative;

      &::after {
        content: '';
        display: none;
      }

      &::before {
        display: none;
      }

      .el-menu-item,
      .el-submenu {
        &::before,
        &::after {
          display: none;
        }
      }
    }

    .el-menu-item-group__title {
      padding: 15px 0 0px 20px;
      color: transparentize(var(--text-color), 0.65);
    }
  }

  &.el-menu--collapse {
    .el-menu-item-group__title {
      padding: 15px 0 0px 0px;
      width: 100%;
      text-align: center;
    }

    .el-submenu__title:hover,
    .el-menu-item:hover {
      background-color: transparent !important;
    }
  }

  &.el-menu--horizontal {
    white-space: nowrap;
    overflow: hidden;
    display: table;

    & > * {
      float: inherit !important;
      display: inline-block;
    }
  }

  &.nav-collapsed {
    .el-menu-item,
    .el-submenu__title {
      & > span,
      .el-submenu__icon-arrow {
        display: none;
      }
    }
  }
}

.main-navigation-submenu {
  .el-menu {
    background: var(--the-menu-bg-color) !important;
    /* border: 1px solid var(--aluminum-700); */

    .body1 {
      color: white;
    }

    .el-menu-item.is-active:not(.plain-text) {
      background-color: none !important;
      opacity: 0.5;
    }

    .el-menu-item:not(.plain-text):hover {
      background-color: transparent !important;
    }

    .el-menu-item.plain-text:hover {
      background-color: #101f31 !important;
    }
  }

  .el-menu--popup-right-start {
    margin: 0px;
    padding: 0px;
  }
}

.asset-count-badge {
  height: 18px;
  width: 37px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 9px;
  background-color: #ee3354;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
}
</style>

<style scoped>
.format-text {
  font-size: 12px;
  font-weight: 500;
  color: #b7bcc1;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheNav.vue